import * as React from 'react';
import { SelectInput, useGetList, useLocaleState } from 'react-admin';
import { dedupeCityChoices, normalizeCityId } from '../../utils/cityChoices';

/**
 * cities koleksiyonundan tekrarsiz sehir listesi (nicosia/lefkosa gibi alias'lar birlestirilir).
 */
const CitySelectInput = ({ source = 'city', disabled, fullWidth, validate, ...rest }) => {
  const [locale] = useLocaleState();
  const localeNameKey = locale === 'tr' ? 'name.tr' : 'name.en';
  const { data: cities = [], isLoading } = useGetList('cities', {
    pagination: { page: 1, perPage: 200 },
    sort: { field: 'id', order: 'ASC' },
  });

  const choices = React.useMemo(
    () => dedupeCityChoices(cities, locale),
    [cities, locale],
  );

  return (
    <SelectInput
      {...rest}
      source={source}
      choices={choices}
      optionText={localeNameKey}
      optionValue="id"
      disabled={disabled}
      isLoading={isLoading}
      fullWidth={fullWidth}
      validate={validate}
      format={normalizeCityId}
      parse={normalizeCityId}
    />
  );
};

export default CitySelectInput;
